import { forwardRef, type InputHTMLAttributes } from "react";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Marks the control as invalid: red edge and aria-invalid. */
  invalid?: boolean;
}

const BASE =
  "h-11 w-full rounded-control border bg-board px-3 text-operate text-ink placeholder:text-ink-3 disabled:bg-ice-2 disabled:text-ink-3";

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid = false, className = "", ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={`${BASE} ${invalid ? "border-red" : "border-edge"} ${className}`}
      {...rest}
    />
  );
});
